import { MantenimientosRutas, ParametroRutas, GetResponseBody, GetHeaderRequest, } from './RutasConfig';


export const Call_Center_Agregar = async (pToken, Id, EmpId, Nombre, Telefonos, Mail, CadenaId) => {
    const data = { Id, EmpId, Nombre, Telefonos, Mail, CadenaId };
    const result = await fetch(MantenimientosRutas.Call_Center_Agregar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Call_Center_Modificar = async (pToken, Id, EmpId, Nombre, Telefonos, Mail, CadenaId) => {
    const data = { Id, EmpId, Nombre, Telefonos, Mail, CadenaId };
    const result = await fetch(MantenimientosRutas.Call_Center_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Call_Center_Eliminar = async (pToken, Id, EmpId) => {
    const data = { Id, EmpId };
    const result = await fetch(MantenimientosRutas.Call_Center_Eliminar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Call_Center_Detalle = async (pToken, Id, EmpId) => {
    const data = { Id, EmpId };
    const result = await fetch(MantenimientosRutas.Call_Center_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Cadenas_Empresa = async (pToken, EmpId) => {
    const data = { EmpId };
    const result = await fetch(MantenimientosRutas.Obtener_Cadenas_Empresa, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const ParametroCallCenter_Agregar = async (pToken, pParametros) => {
    const result = await fetch(MantenimientosRutas.ParametroCallCenter_Agregar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pParametros)
    });
    return await GetResponseBody(result);
};

export const ParametroCallCenter_Modificar = async (pToken, pParametros) => {
    const result = await fetch(MantenimientosRutas.ParametroCallCenter_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pParametros)
    });
    return await GetResponseBody(result);
};

export const ParametroCallCenter_Eliminar = async (pToken, Emp_id, CC_Id) => {
    const data = { Emp_id, CC_Id };
    const result = await fetch(MantenimientosRutas.ParametroCallCenter_Eliminar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const ParametroCallCenter_Detalle = async (pToken, Emp_id, CC_Id) => {
    const data = { Emp_id, CC_Id };
    const result = await fetch(MantenimientosRutas.ParametroCallCenter_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Servicio_Lista = async (pToken, Emp_Id) => {
    const data = { Emp_Id };
    const result = await fetch(MantenimientosRutas.Servicio_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Pais_Lista = async (pToken) => {
    const result = await fetch(MantenimientosRutas.Pais_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: ''
    });
    return await GetResponseBody(result);
};

export const Tipo_Movimiento_Inv_Lista = async (pToken, Emp_Id) => {
    const data = { Emp_Id };
    const result = await fetch(MantenimientosRutas.Tipo_Movimiento_Inv_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Cliente_Detalle = async (pToken, Emp_Id, Cadena_Id, Cliente_Id) => {
    const data = { Emp_Id, Cadena_Id, Cliente_Id };
    const result = await fetch(MantenimientosRutas.Cliente_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Cliente_Lista = async (pToken, Emp_Id, Cadena_Id, Filtro) => {
    const data = { Emp_Id, Cadena_Id, Filtro };
    const result = await fetch(MantenimientosRutas.Cliente_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Zona_Lista = async (pToken, Emp_Id, CC_id) => {
    const data = { Emp_Id, CC_id };
    const result = await fetch(MantenimientosRutas.Zona_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Zona_Eliminar = async (pToken, Emp_Id, CC_id, Id) => {
    const data = { Emp_Id, CC_id, Id };
    const result = await fetch(MantenimientosRutas.Zona_Eliminar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Zona_Modificar = async (pToken, Emp_Id, CC_id, Id, Nombre, Detalle, HoraInicio, HoraFinal) => {
    const data = { Emp_Id, CC_id, Id, Nombre, Detalle, HoraInicio, HoraFinal };
    const result = await fetch(MantenimientosRutas.Zona_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Zona_Agregar = async (pToken, Emp_Id, CC_id, Id, Nombre, Detalle, HoraInicio, HoraFinal) => {
    const data = { Emp_Id, CC_id, Id, Nombre, Detalle, HoraInicio, HoraFinal };
    const result = await fetch(MantenimientosRutas.Zona_Agregar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Zona_Detalle = async (pToken, Emp_Id, CC_id, Id) => {
    const data = { Emp_Id, CC_id, Id };
    const result = await fetch(MantenimientosRutas.Zona_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const SucursalesZona_Lista = async (pToken, Emp_Id, CC_id, Zona_id) => {
    const data = { Emp_Id, CC_id, Zona_id };
    const result = await fetch(MantenimientosRutas.SucursalesZona_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const SucursalZona_Obtener_Sucursales_CallCenter = async (pToken, Emp_Id, CC_id) => {
    const data = { Emp_Id, CC_id };
    const result = await fetch(MantenimientosRutas.SucursalZona_Obtener_Sucursales_CallCenter, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Sucursales_Lista = async (pToken, Emp_Id, CadenaId) => {
    const data = { Emp_Id, CadenaId };

    const result = await fetch(MantenimientosRutas.Obtener_Sucursales_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const ListaSucursalesPorZonaGuardar = async (pToken, Lista, Emp_Id, CC_id, Zona_id) => {
    const data = { Lista, Emp_Id, CC_id, Zona_id };
    const result = await fetch(MantenimientosRutas.ListaSucursalesPorZonaGuardar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

/* Mantenimiento de colores */

export const Colores_Lista = async (pToken, Emp_Id) => {
    const data = { Emp_Id };
    const result = await fetch(MantenimientosRutas.Colores_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Color_Detalle = async (pToken, Emp_Id, CC_id) => {
    const data = { Emp_Id, CC_id };
    const result = await fetch(MantenimientosRutas.Color_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Color_Eliminar = async (pToken, Emp_Id, Id) => {
    const data = { Emp_Id, Id };
    const result = await fetch(MantenimientosRutas.Color_Eliminar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Color_Agregar = async (pToken, Emp_Id, Color_Id, Nombre) => {
    const data = { Emp_Id, Color_Id, Nombre };
    const result = await fetch(MantenimientosRutas.Color_Agregar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Color_Modificar = async (pToken, Emp_Id, Color_Id, Nombre) => {
    const data = { Emp_Id, Color_Id, Nombre };
    const result = await fetch(MantenimientosRutas.Color_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

/* Mantenimiento de Repartidores */

export const Repartidores_Lista = async (pToken, Emp_Id, CC_id) => {
    const data = { Emp_Id, CC_id };
    const result = await fetch(MantenimientosRutas.Repartidores_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Repartidor_Detalle = async (pToken, Emp_Id, CC_id, Id) => {
    const data = { Emp_Id, CC_id, Id };
    const result = await fetch(MantenimientosRutas.Repartidor_Detalle, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Repartidor_Eliminar = async (pToken, Emp_Id, CC_id, Id) => {
    const data = { Emp_Id, CC_id, Id };
    const result = await fetch(MantenimientosRutas.Repartidor_Eliminar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Repartidor_Agregar = async (pToken, Emp_id, CC_Id, Repartidor_Id, Nombre, Estatus, Suc_Id) => {
    const data = { Emp_id, CC_Id, Repartidor_Id, Nombre, Estatus, Suc_Id };
    const result = await fetch(MantenimientosRutas.Repartidor_Agregar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Repartidor_Modificar = async (pToken, Emp_id, CC_Id, Repartidor_Id, Nombre, Estatus, Suc_Id) => {
    const data = { Emp_id, CC_Id, Repartidor_Id, Nombre, Estatus, Suc_Id };
    const result = await fetch(MantenimientosRutas.Repartidor_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

/* Mantenimiento de Tiempos */

export const Tiempos_Lista = async (pToken, Emp_id) => {
    const data = { Emp_id };
    const result = await fetch(MantenimientosRutas.Tiempos_Lista, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Tiempo_Modificar = async (pToken, Emp_id, Estatus_Id, Nombre, Maximo, Cambio) => {
    const data = { Emp_id, Estatus_Id, Nombre, Maximo, Cambio };
    const result = await fetch(MantenimientosRutas.Tiempo_Modificar, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};